import React, { useState, useContext, useEffect } from "react";
import { AiFillPlusCircle } from "react-icons/ai";
import { MdOutlineIosShare } from "react-icons/md";
import { AuthContext } from "../../context/AuthContext.js";
import { useParams } from "react-router-dom";
import "./WishList.css";
// import ImageTemplate from "../../pages/sharepost/ImageTemplate.jsx";
// import useImageHandling from "../../hooks/useImageHandling.jsx";
import axios from "axios";
import config from "../../config";
import Gift from "../../components/post/Gift.jsx";
import Popup from "../../components/popup/Popup";
import WishListItem from "../../components/wishlist/WishListItem";
import SharePostModal from "../../components/post/sharepost/SharePostModal.jsx";
import ImageProcessor from "../../components/imageProcessor/ImageProcessor.jsx";

export default function wishList({ setShowTopbar, setIsAccountBalanceModalOpen }) {
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [items, setItems] = useState([]);
  const [isFetchingWishlist, setIsFetchingWishlist] = useState(true);  
  const { user } = useContext(AuthContext);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [details, setDetails] = useState(null);
  const [triggerImageProcessor, setTriggerImageProcessor] = useState(false);
  const [isDoneProcessing, setIsDoneProcessing] = useState(false);
  const activeWishlistUsername = useParams();
  // function to show popup used in the catch blocks
  const popupStatus = async (message) => {
    setPopupMessage(message);
    setShowPopup(true);
  };

  // hook to fetch wishlist items when component mounts
  useEffect(() => {
    const fetchWishlist = async () => {
      try {
        console.log("active wishlist username: ", activeWishlistUsername.username);
        const res = await axios.get(
          `${config.apiUrl}/wishlists/${activeWishlistUsername.username}`
        );
        if (res.data.userWishlist && res.data.userWishlist.items) {
          setItems(res.data.userWishlist.items || []);
          const newDetails = {
            type: "wishlist",
            wishlistItems: res.data.userWishlist.items || [],
            giveorreceive: "receive",
            username: activeWishlistUsername.username,
          };
          setDetails(newDetails);
         
          if(user.username === activeWishlistUsername.username){
            // render images, process for server
            setTriggerImageProcessor(true);
            setIsDoneProcessing(false);
            console.log("triggering image processor now...");
          }
        }
      } catch (error) {
        popupStatus(
          "An errror occured when trying to load this wishlist. Please try again later.",
          "Close"
        );
      } finally {
        setIsFetchingWishlist(false);
      }
    };
      fetchWishlist();
  },[activeWishlistUsername]);

  // click on item from search results, show item in wishlist
  const handleItemClick = (item) => {
    console.log("item in WishList.jsx", item);
    setShowSearchBar((prev) => !prev);
    if (!item.price) {
      popupStatus(
        "There was an error loading this item's information. Please try again later.",
        "Close"
      );
      return;
    }

    let shippingPrice;
    if (item.shippingPrice || item.shippingPrice === 0) {
      shippingPrice = item.shippingPrice;
    } else {
      popupStatus(
        "Item shipping options are missing or malformed. Please try again later.",
        "Close"
      );
      console.error("Item shipping options are missing or malformed", item);
    }

    // create variable used for database model
    let newItem = {
      itemId: item.itemId,
      name: item.name,
      imageUrl: item.imageUrl,
      allImages: item.allImages,
      description: item.description,
      price: item.price,
      shippingPrice: shippingPrice,
      purchased: false,
    };
    // add item to item state, to be added to database on save
    setItems([newItem, ...items]);
  };

  // show or hide the search bar
  const handleAddItemClick = () => {
    setShowSearchBar((prev) => !prev);
  };

  const removeItem = (itemToRemove) => {
    // remove items from items state, this is passed to the wishlistitem component
    setItems((prevItems) => prevItems.filter((item) => item !== itemToRemove));
  };

  // update wishlist in database, process images for download
  const updateWishlist = async () => {
    // render images, process for server
    setTriggerImageProcessor(true);
    setIsDoneProcessing(false);

    const updateWishlist = {
      username: user.username,
      items: items,
    };
    const token = localStorage.getItem("token");

    await axios.put(`${config.apiUrl}/wishlists/update`, updateWishlist, {
      headers: {
        "x-auth-token": token,
      },
    });
  };

  // set wishlist details for sharePostModal and imageTemplate
  useEffect(() => { 
    if(user.username === activeWishlistUsername.username){
      if (!isFetchingWishlist && items.length > 0) {
        const newDetails = {
          type: "wishlist",
          wishlistItems: items,
          giveorreceive: "receive",
          username: activeWishlistUsername.username,
        };
        setDetails(newDetails);
        // save wishlist, process images, save image to indexed DB
        updateWishlist();
      }
    }
  }, [items]);

  const handleShareWishlist = () => {
    setIsModalOpen(true);
  };

  const handleProcessingComplete = () => {
    console.log("Processing complete, resetting trigger...");
    setTriggerImageProcessor(false); // Reset the trigger
    setIsDoneProcessing(true); // Mark processing as done
  };

  useEffect(() => {
    if(isDoneProcessing){
      console.log("done processing, setting trigger back to false");
    }
  },[isDoneProcessing])

  return (
    <div className="wishlist-wrapper">
      <Popup
        isPopupOpen={showPopup}
        message={popupMessage}
        button1Text="Close"
        button1Action={() => setShowPopup(false)}
      />
      <div className="title-container">
        <h1 className="wishlist-title">
          {activeWishlistUsername.username}&apos;s wishlist
        </h1>
      </div>

      {/* ONLY SHOW EDITING FEATURES IF WISHLIST IS CURRENT USER'S */}
      {activeWishlistUsername.username == user.username && (
        <>
          <div className="adjust-wishlist-btn-container">
            <div className="add-save-btn-container">
              {items.length < 7 && (
                <AiFillPlusCircle
                  className="add-item-icon"
                  onClick={handleAddItemClick}
                />
              )}

              <MdOutlineIosShare
                className="share-list-icon"
                onClick={handleShareWishlist}
              />
            </div>
            <div className="search-bar-container">
              {showSearchBar && (
                <div className="search-results-container">
                  <Gift onItemClick={handleItemClick} />
                </div>
              )}
            </div>
          </div>
        </>
      )}
      <div className="wishlist-item-list-container">
        {items?.map((i, index) => (
          <WishListItem
            key={i._id + "-" + index}
            item={i}
            removeItem={removeItem}
            setShowTopbar={setShowTopbar}
            setIsAccountBalanceModalOpen={setIsAccountBalanceModalOpen}
          />
        ))}
      </div>

      {/* ONLY SHOW EDITING FEATURES IF WISHLIST IS CURRENT USER'S */}
      {activeWishlistUsername.username == user.username && (
        <div className="instructions-container">
          <p>
            Add up to seven items in your wishlist & share with friends or
            family
          </p>
        </div>
      )}
      {details ? (
        <SharePostModal
          isOpen={isModalOpen}
          closeModal={() => setIsModalOpen(false)}
          details={details}
          className={isModalOpen ? "modal.open" : "modal-hidden"}
          // shouldRenderOffscreen={shouldRenderOffscreen}
          // generatedElements={generatedElements}
          // isLoadingImage={isLoadingImage}
        />
      ) : (
        <></>
      )}

      {/* upscaling for downloaded images */}
      {user.username === activeWishlistUsername.username &&
        <ImageProcessor
            username={user.username}
            details={details}
            trigger={triggerImageProcessor}
            // setTriggerImageProcessor={setTriggerImageProcessor}
            onDoneProcessing={handleProcessingComplete}
          />
      }
    </div>
  );
}
